import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import API_BASE_URL from "../config";

export default function PublicRoute({ children }) {
  const [loading, setLoading] = useState(true);
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  useEffect(() => {
    fetch(`${API_BASE_URL}/auth/check_session`, {
      credentials: "include",
    })
      .then((res) => res.json())
      .then((data) => {
        setIsLoggedIn(data.status === "active");
        setLoading(false);
      })
      .catch(() => {
        setIsLoggedIn(false);
        setLoading(false);
      });
  }, []);

  if (loading) return <div>Loading...</div>;

  return isLoggedIn ? <Navigate to="/home" /> : children;
}
